module.exports = __webpack_public_path__ + "static/media/planet_logo.f97decd1.png";